import React, { useContext } from 'react';
import Head from 'next/head';
import { useRouter } from 'next/router';

import { eventGtag } from '#app/hooks/eventGtag';
import { DashboardHeroSection, UserDropdown } from '#components/index';
import { FrecuencyAskCard, ContactUsCard } from '#atoms/index';
import { useUserContext } from '#hooks/index';
import { H4 } from '#styleguide/index';
import Navegation from '#layout/navegation';
import { WhatsAppLogo } from '#layout/helpers';

import GlobalContext from '../../context/Global/GlobalContext';

const ContactSupport = () => {
  const {
 cleanPrevPath, isLoginUser, updateCurrentPosition, cleanPurchaseData 
} =
    useContext(GlobalContext);
  const router = useRouter();
  const { loading, data } = useUserContext({ withVerification: true });
  const userContextData = { loading, data };

  const onClickLogout = () => {
    window.localStorage.removeItem('accessToken');
    window.localStorage.removeItem('refreshToken');
    window.localStorage.removeItem('userData');
    isLoginUser(false);
    updateCurrentPosition('register');
    cleanPurchaseData();
    cleanPrevPath();
    router.push('/login');
    eventGtag('cerrar_sesion_menu', userContextData.data);
  };

  return (
    <>
      <Head>
        <title>Soporte - Dashboard | Crack The Code</title>
      </Head>
      <Navegation>
        <div className="navbar">
          {!userContextData?.loading && userContextData?.data && (
            <UserDropdown
              data={userContextData.data}
              onClickLogout={onClickLogout}
              isLetterAvatar={true}
            />
          )}
        </div>
        <div className="contact-support__container">
          <div className="contact-support__title">
            <H4>Contactar a soporte</H4>
          </div>
          <DashboardHeroSection content="Escríbenos en caso tengas alguna consulta o duda." />
          <div className="contact_support_content">
            <ContactUsCard variant="form-dashboard" />
            <FrecuencyAskCard />
          </div>
          <WhatsAppLogo fixLanding msg="Tengo una duda o problema" />
        </div>
      </Navegation>
    </>
  );
};

export default ContactSupport;
